import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Info, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative mt-auto overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/8 via-background to-background dark:from-primary/5" />

      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto py-8 sm:py-10">
          {/* EU + MŠMT Logo */}
          <div className="flex justify-center mb-4">
            <img
              src="/msmt_logo.png"
              alt={t(
                "Spolufinancováno Evropskou unií – Ministerstvo školství, mládeže a tělovýchovy",
                "Spolufinancované Európskou úniou – Ministerstvo školstva, mládeže a telovýchovy"
              )}
              className="h-10 sm:h-14 w-auto object-contain"
            />
          </div>

          {/* EU Project Funding Text */}
          <div className="text-center mb-6">
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              {t(
                "Tato aplikace byla vytvořena v rámci projektu Nové technologie a proměny vzdělávání, výzkumu a trhu práce, reg. č. CZ.02.01.01/00/23_025/0008693 spolufinancovaného EU",
                "Táto aplikácia bola vytvorená v rámci projektu Nové technológie a premeny vzdelávania, výskumu a trhu práce, reg. č. CZ.02.01.01/00/23_025/0008693 spolufinancovaného EÚ"
              )}
            </p>
          </div>

          {/* Buttons Row */}
          <div className="flex justify-center gap-4 mb-6">
            <Link to="/contact">
              <Button variant="outline" size="sm" className="gap-2">
                <Phone className="w-4 h-4" />
                {t("Kontakt", "Kontakt")}
              </Button>
            </Link>
            <Link to="/about">
              <Button variant="outline" size="sm" className="gap-2">
                <Info className="w-4 h-4" />
                {t("O aplikaci", "O aplikácii")}
              </Button>
            </Link>
          </div>

          {/* Operator name */}
          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} Scio Research, s.r.o.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
